import React from "react";

export default class ReportBundlePackageZones extends React.Component{
  constructor(props){
    super(props);
    this.state={
      option1:null,
      geography: [],
      selectedZone:null
    }
  }

  /* istanbul ignore next */
  selectArea(state){
    this.props.onSelectingReportBundleGeography([state])
    this.props.onGeographyClickAction()

    this.setState({
      option1:state
    })
  }

  componentDidMount() {
    this.setState({
      option1:this.props.selectedGeography.states === null ? null : this.props.selectedGeography.states[0]
    })
  }

  render(props){
    const legacySelectStyle = {
      border: '1px solid #a805fb',
      backgroundColor: '#f7efe2',
      color: 'midnightblue'
    }

    return (
      <div className="panel-body-spacing">
        <div className="alert alert-success">
          <div className="row font-14 no-margin">
            <div className="col-sm-12 no-padding">
              <div className='product-config-select-wrap'>
                <select
                  id='areas'
                  className='form-control font-14'
                  style={legacySelectStyle}
                  value={this.state.option1 || ''}
                  onChange={(event) => {
                    this.selectArea(event.target.value);
                  }}
                >
                  <option value=''>Select</option>
                  {this.props.geography.states.map(function(state, index){
                    return (
                      <option id={"menuItemArea_" + state} key={index} value={state}>{state}</option>
                    )
                  })}
                </select>
                <span className='caret product-config-caret'></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
